import React from 'react';
export function CostWarning() {
  return <div className="max-w-3xl mx-auto mb-8" data-id="element-76">
      <div className="bg-red-50 border-l-4 border-red-600 p-6 rounded-r-lg" data-id="element-77">
        <p className="font-display text-lg md:text-xl text-brand-primary leading-relaxed italic" data-id="element-78">
          ¿Cuánto te cuesta una sesión cancelada sin aviso? ¿O una multa por no
          cumplir el RGPD? El Pack Premium se paga solo al salvar tu primera
          sesión no asistida.
        </p>
      </div>
    </div>;
}